module.exports = __webpack_public_path__ + "img/pay.ae9ad160.jpg";